import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const styles: StyleRulesCallback = () => ({
  root: {
    zIndex: 10002,
  },
});

export default styles;
